/*
 * File: PatientEditPage.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Controls the patient edit form
 */

import React, { Component } from "react";
import FormBuilder from "components/form-builder";
import DemographicFormModel from "../store/DemographicFormModel";
import FormStore from "components/form-builder/FormStore";
import PropTypes from "prop-types";
import UIProgress from "components/ui/UIProgress";
import References from "services/references/References";
import Users from "services/users/Users";
import { StoreContext } from "utils/useStore";

class PatientEditPage extends Component {
  formStore = FormStore.create();
  state = { loading: true };

  static contextType = StoreContext;

  componentDidMount() {
    this.populateSelectFields();
    this.formStore.setFields(DemographicFormModel);
  }

  async populateSelectFields() {
    const references = this.context.getStore(References);
    const offices = await references.forSelect("offices");
    const feeSchedules = await references.forSelect("feeSchedules");
    const providers = await this.context.getStore(Users).forSelect("providers");
    const maritalStatus = await references.forSelect("maritalStatusTypes");
    const employments = await references.forSelect("employmentStatusTypes");
    const languages = await references.forSelect("languages");
    const relationships = await references.forSelect("relationshipTypes");

    this.setFormOptions("patientOffice", offices);
    this.setFormOptions("feeSchedule", feeSchedules);
    this.setFormOptions("patientProvider", providers);
    this.setFormOptions("accountProvider", providers);
    this.setFormOptions("maritalStatus", maritalStatus);
    this.setFormOptions("employment", employments);
    this.setFormOptions("preferredLanguageId", languages);
    this.setFormOptions("relationshipToPrimary", relationships);
    this.setFormOptions("relationshipToSecondary", relationships);

    this.setState({
      loading: false
    });
  }

  setFormOptions(key, val) {
    let fieldModel = this.formStore.getFieldByName(key);
    if (fieldModel) {
      fieldModel.setFormOptions(val);
    }
  }

  onChange = (key, val) => {
    if (key === "phone1" || key === "phone2" || key === "phone3") {
      this.props.patient.updatePhone(key, val);
    } else if (
      key === "phone1Type" ||
      key === "phone2Type" ||
      key === "phone3Type"
    ) {
      this.props.patient.updatePhoneType(key, val);
    } else {
      this.props.patient.update(key, val);
    }
  };

  editPageSubmit = async () => {
    await this.props.patient.updatePatient();
    this.props.parentCallBack();
  };

  onCancel = () => {
    this.props.parentCallBack();
  };

  render() {
    const { loading } = this.state;

    if (loading) return <UIProgress />;
    return (
      <FormBuilder
        formStore={this.formStore}
        data={this.props.patient}
        parentOnChange={this.onChange}
        parentOnSubmit={this.editPageSubmit}
        parentOnCancel={this.onCancel}
        formName={"PatientEdit"}
      />
    );
  }
}

PatientEditPage.propTypes = {
  patient: PropTypes.object.isRequired,
  parentCallBack: PropTypes.func.isRequired
};

export default PatientEditPage;
